export default [{
	titulo: 'Convênios',
	icone: 'menu-icon fa fa-caret-right',
	url: '/servicos/convenios',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]